import { useEffect, useState } from 'react';

import useReadRecipe from 'domain/recipe/useReadRecipe';
import useAuthentication from 'domain/authentication/useAuthentication';

const useEditRecipeBodyStep = (id) => {
  const { user } = useAuthentication();
  const [recipeContent, setRecipeContent] = useState(null);

  const Read = useReadRecipe(id, 25);

  const onRecipeSaved = (savedRecipeContent) =>
    setRecipeContent(savedRecipeContent);

  useEffect(() => {
    if (Read.recipe) setRecipeContent(Read.recipe.content);
  }, [Read.recipe]);

  return {
    Read,

    recipeContent,
    onRecipeSaved,

    userOwnsRecipe: Read.hasLoaded && user.id === Read.recipe.userID,
  };
};

export default useEditRecipeBodyStep;
